"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Chain;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Chain(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "chain"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M90.621,9.379a14.448,14.448,0,0,0-20.409,0L53.866,25.726A14.452,14.452,0,0,0,52.26,44.205l-8.271,8.271a13.181,13.181,0,0,0-17.7.83L8.152,71.44a13.2,13.2,0,0,0,0,18.621L9.94,91.849a13.2,13.2,0,0,0,18.621,0L46.7,73.714a13.2,13.2,0,0,0,.831-17.7l8.266-8.266a14.226,14.226,0,0,0,8.241,2.593,14.493,14.493,0,0,0,10.241-4.2L90.621,29.788A14.449,14.449,0,0,0,90.621,9.379ZM45.539,64.4a8.108,8.108,0,0,1-2.379,5.776L25.025,88.313a8.2,8.2,0,0,1-11.549,0l-1.789-1.788a8.2,8.2,0,0,1,0-11.549L29.821,56.841a8.186,8.186,0,0,1,10.6-.8l-8.968,8.968a2.5,2.5,0,0,0,3.535,3.535l8.969-8.969A8.112,8.112,0,0,1,45.539,64.4Zm41.547-38.15L70.739,42.6a9.516,9.516,0,0,1-10.484,1.952,9.265,9.265,0,0,1-.844-.427l8.8-8.8a2.5,2.5,0,0,0-3.535-3.535l-8.8,8.8A9.462,9.462,0,0,1,57.4,29.261L73.747,12.914A9.432,9.432,0,0,1,87.086,26.253Z"
  }))));
}